export default "__VITE_ASSET__D4Zrz35h__"